import { useEffect } from 'react';
import amplitude from '../services/amplitude';

export const useAmplitudeSuccessPageview = ({
  ticketId,
  plateNumber,
}: {
  ticketId: string;
  plateNumber: string;
}) => {
  useEffect(() => {
    amplitude.successPageView({ ticketId, plateNumber });
  }, [ticketId, plateNumber]);
};
